import React, { useCallback, useEffect, useRef, useState } from 'react'
import CustomizeOption from '../components/CustomizeOption'
import CustomizeModal from '../components/CustomizeModal';
import { t } from '../../../utilities/translator';
import Counter from '../../../components/Counter';
import EngineTutorial from '../components/messages/EngineTutorial';
import AgeSelect from '../../../components/AgeSelect';
import { pushEvent } from '../../../utilities/analytics';
import {
  CUSTOMIZE_WHO_CLICKED,
  CUSTOMIZE_WHO_INCREASE_ROOM_CLICKED,
  CUSTOMIZE_WHO_SAVED,
  OPEN_LOGIN_BLOCK,
  CLOSE_LOGIN_BLOCK,
  MAYBELATER_LOGIN_BLOCK,
  BIG_GROUP_CLICK,
} from '../../../constants/analyticEvents';
import { useDispatch, useSelector } from 'react-redux';
import { toggleCustomizePanel } from '../customizeButtonSlice';
import { CUSTOMIZE, BIG_GROUP_LINK } from '../../../constants/constants';
import { getParamFromUrl } from '../../../utilities/urlResolver';
import LoginBlock from '../../user/LoginBlock';
import Button from '../../../components/button/Button';
import GroupBookingBtn from '../../groupBooking/GroupBookingBtn';
import abTesting from '../../../services/abTesting';

const Who = ({
  selected,
  onSave,
}) => {
  const groupTimeout = useRef();
  const dispatch = useDispatch();
  const { activePanel } = useSelector(state => state.customize);
  const [selectedAdults, setSelectedAdults] = useState(selected.adults);
  const [selectedChildrenAge, setSelectedChildrenAge] = useState(selected.childAges.filter(age => age >= 2));
  const [selectedChildren, setSelectedChildren] = useState(selectedChildrenAge.length);
  const [selectedRooms, setSelectedRooms] = useState(selected.rooms);
  const [selectedInfants, setSelectedInfants] = useState(selected.babies);
  const [showRoomsTip, setShowRoomsTip] = useState(false);
  const [groupBooking, setGroupBooking] = useState(false);
  const userContext = JSON.parse(localStorage.getItem('hf_user'));
  const loginWasClosed = +localStorage.getItem('loginClosed');
  const [isLoginOpen, setLoginOpen] = useState(false);
  const [showLoginBtn, setShowLoginBtn] = useState(!((loginWasClosed > Date.now()) || (userContext && userContext?.user?.userLevel === 'USER_EMAIL' && userContext?.user?.user_auth)));
  const loginTriggerTxt = "Passengers filter (customize filters)";

  useEffect(() => {
    setSelectedAdults(selected.adults);
    setSelectedChildren(selected.childAges.filter(age => age >= 2).length);
    setSelectedChildrenAge(selected.childAges.filter(age => age >= 2));
    setSelectedRooms(selected.rooms);
    setSelectedInfants(selected.babies);
  }, [selected.adults, selected.children, selected.childAges, selected.rooms, selected.babies]);

  const onOpenLogin = () => {
    setLoginOpen(true);
    // eslint-disable-next-line no-undef
    if (typeof closeSubscribeLogin !== 'undefined') {
      // eslint-disable-next-line no-undef
      closeSubscribeLogin();
    }
    pushEvent(OPEN_LOGIN_BLOCK, { sourceBlock: loginTriggerTxt });
  };

  const loginPopupClose = () => {
    setLoginOpen(false);
    setShowLoginBtn(false);
    pushEvent(CLOSE_LOGIN_BLOCK, { sourceBlock: loginTriggerTxt });
  };

  const loginPopupCloseLogIn = () => {
    setLoginOpen(false);
    setShowLoginBtn(false);
  };

  useEffect(() => {
    window.addEventListener('userLoggedIn', loginPopupCloseLogIn);

    if (getParamFromUrl('openFilter') && getParamFromUrl('openFilter') === 'who') {
      dispatch(toggleCustomizePanel(CUSTOMIZE.WHO));
    }

    return () => {
      window.removeEventListener('userLoggedIn', loginPopupCloseLogIn);
    };
  }, [dispatch]);

  useEffect(() => {
    setShowLoginBtn(!((loginWasClosed > Date.now()) || (userContext && userContext?.user?.userLevel === 'USER_EMAIL' && userContext?.user?.user_auth)));
  }, [loginWasClosed, userContext?.user?.user_auth]);

  const getOptionLabel = () => {
    const children = selected.childAges.filter(age => age >= 2).length;
    return `${selected.adults} ${t("general.adults_plural", { count: selected.adults })}, ${
      children > 0
        ? children + ` ${t("general.children_plural", { count: children })},`
        : ""
    } ${
      selected.babies > 0
        ? selected.babies + ` ${t("general.infants_plural", { count: selected.babies })},`
        : ""
    } ${selected.rooms} ${t("general.rooms_plural", { count: selected.rooms })}`;
  }

  const handleOptionClick = () => {
    dispatch(toggleCustomizePanel(CUSTOMIZE.WHO));
    pushEvent(CUSTOMIZE_WHO_CLICKED);
    clearTimeout(groupTimeout.current);
  }

  const handleChangeChildren = (value) => {
    let updatedChildren = value;
    if (selectedAdults + selectedInfants + value > 5) {
      updatedChildren = 5 - selectedAdults - selectedInfants;
      setGroupBooking(true);
    }
    if (updatedChildren > 3) {
      updatedChildren = 3;
    }

    if (updatedChildren < selectedChildren) {
      setGroupBooking(false);
    }

    setSelectedChildren(updatedChildren);

    if (updatedChildren > selectedChildrenAge.length) {
      setSelectedChildrenAge((childrenAge) => [
        ...childrenAge,
        7,
      ]);
    } else {
      setSelectedChildrenAge((childrenAge) => childrenAge.slice(0, updatedChildren));
    }
  }

  const handleChangeInfants = (value) => {
    if (selectedAdults + selectedChildren + value > 5) {
      setSelectedInfants(5 - selectedAdults - selectedChildren);
      setGroupBooking(true);
      return;
    }
    setSelectedInfants(value);
  }

  const handleChangeAdults = (value) => {
    let updatedValue = value;
    if (selectedChildren + selectedInfants + value > 5) {
      updatedValue = 5 - selectedChildren - selectedInfants;
      setGroupBooking(true);
    }

    if (updatedValue > 3) {
      updatedValue = 3;
      setGroupBooking(true);
    }

    if (updatedValue < selectedAdults) {
      setGroupBooking(false);
    }

    setSelectedAdults(updatedValue);
  }

  const changeChildAge = useCallback((ind) => (value) => {
    setSelectedChildrenAge(
      selectedChildrenAge.map((chAge, i) => (ind === i ?  value : chAge))
    );
  }, [selectedChildrenAge]);

  const handleClose = () => {
    dispatch(toggleCustomizePanel(null));
    setShowRoomsTip(false);
    setSelectedAdults(selected.adults);
    setSelectedInfants(selected.babies);
    setSelectedChildren(selected.childAges.filter(age => age >= 2).length);
    setSelectedChildrenAge(selected.childAges.filter(age => age >= 2));
    setSelectedRooms(selected.rooms);
    setGroupBooking(false);
  }

  const handleSave = (e, noLogin = false) => {
    // temporary hide login
    /* if (showLoginBtn && !noLogin) {
      onOpenLogin();
      return false;
    } */
    dispatch(toggleCustomizePanel(null));
    setShowRoomsTip(false);
    onSave({
      adults: selectedAdults,
      children: selectedChildren,
      childAges: selectedChildrenAge,
      rooms: selectedRooms,
      babies: selectedInfants,
    })
    pushEvent(CUSTOMIZE_WHO_SAVED);
  }

  const handleClear = () => {
    dispatch(toggleCustomizePanel(null));
    setShowRoomsTip(false);
    onSave({
      adults: 2,
      children: 0,
      babies: 0,
      childAges: [],
      rooms: 1,
    })
  }

  const loginPopupCloseLater = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    setLoginOpen(false);
    setShowLoginBtn(false);
    localStorage.setItem('loginClosed', +tomorrow);
    setTimeout(() => handleSave(false, true), 350);
    pushEvent(MAYBELATER_LOGIN_BLOCK, { sourceBlock: loginTriggerTxt });
  };

  const getMaxCounterValue = (type) => {
    if (type === 'adults') {
      // const limit = 6 - (selectedChildren + selectedInfants);
      // return limit < 3 ? limit : 3;

      return 4
    }

    if (type === 'children') {
      return selectedAdults < 2
        ? 4 - selectedInfants
        : 6 - (selectedInfants + selectedAdults)
    }

    if (type === 'infants') {
      return selectedAdults + selectedChildren >= 6
        ? 0
        : 1
    }
  }

  const handleQuestionMarkClick = () => {
    setShowRoomsTip(true);
    pushEvent(CUSTOMIZE_WHO_INCREASE_ROOM_CLICKED);

    groupTimeout.current = setTimeout(() => {
      setGroupBooking(true);
    }, 2000);
  }

  const loginForm = () => (
    !(userContext && userContext?.user?.userLevel === 'USER_EMAIL' && userContext?.user?.user_auth) &&
      <LoginBlock
        className="login-block-customize-who"
        onClose={loginPopupClose}
        onCloseLater={loginPopupCloseLater}
        isOpen={isLoginOpen}
        type="who"
        sourceBlock={loginTriggerTxt}
      />
  );

  return (
    <>
      <CustomizeOption
        label={t('mainFilter.whos_going_short')}
        value={getOptionLabel()}
        icon="ri-user-3-line"
        onClick={handleOptionClick}
      />

      <CustomizeModal show={activePanel === CUSTOMIZE.WHO} close={handleClose}>
        <CustomizeModal.Header close={handleClose} />

        <CustomizeModal.Body>
          <div className="text-xl font-semibold text-start">{t('mainFilter.whos_going')}</div>
         <div className="guests-counter-new">
            <div className="guests-counter-new__text gap-1 text-start">
              <span className="label-large leading-none capitalize font-semibold">{t("mainFilter.Adults")}</span>
              <span className="body-medium leading-none font-medium text-tertiary">{t("mainFilter.Ages_17_or_above")}</span>
            </div>
            <Counter
              value={selectedAdults}
              min={1}
              max={getMaxCounterValue('adults')}
              variant="new"
              onChange={handleChangeAdults}
            />
          </div>

          <div className="guests-counter-new">
            <div className="guests-counter-new__text gap-1 text-start">
              <span className="label-large leading-none capitalize font-semibold">{t("mainFilter.Children")}</span>
              <span className="body-medium leading-none font-medium text-tertiary">{t("mainFilter.childrenAges")}</span>
            </div>
            <Counter
              value={selectedChildren}
              min={0}
              max={getMaxCounterValue('children')}
              variant="new"
              onChange={handleChangeChildren}
            />
          </div>

          {selectedChildrenAge.filter(age => age > 1).length !== 0 && (
            <div className="move-select-wrap gap-3">
              {selectedChildrenAge.filter(age => age > 1).map((value, ind) => (
                <AgeSelect
                  key={ind}
                  value={value}
                  label={`${t("mainFilter.Child")} ${ind + 1}  ${t("mainFilter.age")}`}
                  changeChildAge={changeChildAge(ind)}
                  infantsCount={1} // To hide under 2 years from selection
                />
              ))}
            </div>
          )}

          <div className="guests-counter-new">
            <div className="guests-counter-new__text gap-1 text-start">
              <span className="label-large leading-none capitalize font-semibold">{t("mainFilter.infants")}</span>
              <span className="body-medium leading-none font-medium text-tertiary">{t("mainFilter.infantAges")}</span>
            </div>
            <Counter
              value={selectedInfants}
              min={0}
              max={getMaxCounterValue('infants')}
              variant="new"
              onChange={handleChangeInfants}
            />
          </div>

          <div className="rooms-separator" />

          <div className="guests-counter-new">
            <span className="label-large capitalize font-semibold"> {t("mainFilter.rooms")}</span>
            <div className='w-[124px] rounded-lg overflow-hidden flex gap-0.5 ms-auto'>
              <div className="move-form-counter flex ms-auto">
                <div className="form-counter__value">1</div>
                <Button
                  label="+"
                  type="secondary"
                  size="md"
                  onClick={handleQuestionMarkClick}
                  className="form-counter__button plus"
                />
              </div>
            </div>
          </div>

          {showRoomsTip && !abTesting.groupBooking && (
            <EngineTutorial delay={0}>
              {t('mainFilter.whoGoingComingSoon')}
            </EngineTutorial>
          )}

          {groupBooking && !abTesting.groupBooking && (
            <div className="mt-auto p-3 rounded bg-info-light text-start scale-in-center">
              <p className="label-large leading-none mb-3">{t('mainFilter.who.bigGroupTitle')}</p>
              <p className="body-medium font-medium mb-0" onClick={() => { pushEvent(BIG_GROUP_CLICK, { type: 'customize' }); }} dangerouslySetInnerHTML={{ __html: t('mainFilter.who.bigGroupText', { link: BIG_GROUP_LINK }) }} />
            </div>
          )}

          {(groupBooking || showRoomsTip) && abTesting.groupBooking && (
            <GroupBookingBtn
              type={showRoomsTip ? 'room' : 'capacity'}
            />
          )}
        </CustomizeModal.Body>

        <CustomizeModal.Footer
          onSave={handleSave}
          onClear={handleClear}
          close={handleClose}
          loginBlock={loginForm()}
        />
      </CustomizeModal>
    </>
  )
}

export default Who
